document.addEventListener("DOMContentLoaded", function () {
    const businessnameField = document.getElementById("business_name");
    const businesslogoField = document.getElementById("business_logo");
    const locationField = document.getElementById("location");
    const suburbField = document.getElementById("suburb");
    const postcodeField = document.getElementById("postcode");
    const websiteField = document.getElementById("business_website_optional");
    const registerWrap = document.querySelector(".register-page-wrap ");
    if (registerWrap) {
        if (businessnameField) {
            businessnameField.placeholder = "Enter your business name";
        }

        if (businesslogoField && businesslogoField.type === "file") {
            // File inputs don’t support placeholder natively, so you may want to add a label or custom message next to it
            businesslogoField.setAttribute("title", "Upload your business logo");
        }

        if (locationField) {
            locationField.placeholder = "Enter your location";
        }

        if (suburbField) {
            suburbField.placeholder = "Enter your suburb";
        }

        if (postcodeField) {
            postcodeField.placeholder = "Enter your postcode";
        }
        if (websiteField) {
            websiteField.placeholder = "www.website.com";
        }
    }
});
